import { _ } from "vue-underscore";

import { voteTypes } from "@/constants/vote.js";

export default {
  state: {},
  mutations: {},
  getters: {
    getVoteByMandateAndResolution: state => (mandateId, meetingResolutionId) => {
      return _.find(Object.values(state.data), item => {
        return (
          item.mandate_id == mandateId && item.meeting_has_resolution_id == meetingResolutionId
        );
      });
    },
    getVotesThatMeanSomethingByResolution: state => meetingResolutionId => {
      return _.filter(Object.values(state.data), item => {
        return (
          item.meeting_has_resolution_id == meetingResolutionId &&
          item.vote != null &&
          item.vote != voteTypes.nsp
        );
      });
    },
  },
  actions: {},
};
